<template>
    <div>
        <template v-if="loading">
            <i class="fas fa-cog fa-spin"></i> Loading...
        </template>
        <template v-else>
            <vue-headful :title="'[Reset User Password] ' + user.first_name + ' '+user.last_name+' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/users">Users</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/users/view/${user.id}`">{{ user.first_name }} {{ user.last_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Reset Password
                    </li>

                </ol>
            </nav>

            <h4 class="page-header mb-4">
                <span class="text-muted">{{ user.first_name }} {{ user.last_name }} / </span> Reset Password
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card">
                        <div class="card-header">Reset Password</div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <p>You are about to send the user password reset email. This email will contain a link to reset their password. It expires in 60 minutes. The email will be sent to: <strong>{{ user.email }}</strong></p>
                                <p v-if="user.is_active === 0">This user is current inactive, but they will automatically be re-activated.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">

                </div>
            </div>

            <button type="button" class="btn btn-sm btn-success" v-on:click="resetPassword" :disabled="saving">
                <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Sending...</template>
                <template v-else><i class="fas fa-envelope"></i> Send Password Reset Email</template>
            </button>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                user: {},
            }
        },

        computed: {

        },

        methods: {
            //Get the Customer
            getUser(){
                //Send it
                this.$http.get('/users/view/'+this.id)
                    .then(response => {
                        //Set the user
                        this.user = response.data.user;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            resetPassword(){
                //Saving
                this.saving = true;

                //Send it
                this.$http.post('/users/reset-password/'+this.id)
                    .then(response => {
                        //Set the user
                        this.$router.push('/users/view/'+this.user.id);

                        //Alert
                        this.$toastr.s('Password Reset Email Sent');
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the user
            this.getUser();
        }
    }
</script>
